/*
 * Copyright (c) 2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { ReportResponse } from '@cp/customer-database-sdk'
import { DEFAULT_RENDER_FUNCTION, getColumnValue } from './TableColumnHelpers'
import { ColumnDefinitionFn, ColumnRendererRecord, ValidReportColumn } from './types'

const COLUMN_TITLE_MAPPING = {
  title: 'Report Title',
  profilingLink: 'Report Links',
  description: 'Description',
  createdAt: 'Created At'
} satisfies Record<ValidReportColumn, string>

const DEFAULT_COLUMN_RENDERER_MAPPING = {
  title: name => name,
  profilingLink: undefined,
  description: undefined,
  createdAt: undefined
} satisfies ColumnRendererRecord<ReportResponse, ValidReportColumn>

export class ReportTableColumnDefinitionHelpers {
  static getReportColumn: ColumnDefinitionFn<ReportResponse, ValidReportColumn> = (param, renderFn) => ({
    name: param,
    title: COLUMN_TITLE_MAPPING[param],
    render: record => {
      const effectiveRenderFn = renderFn ?? (DEFAULT_COLUMN_RENDERER_MAPPING[param] as typeof renderFn) ?? DEFAULT_RENDER_FUNCTION
      const effectiveValue = getColumnValue(record, param)
      return effectiveRenderFn(effectiveValue, record)
    }
  })
}
